var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-telegram 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.5 2C38.203 2 48.5 12.297 48.5 25C48.5 37.703 38.203 48 25.5 48C12.797 48 2.5 37.703 2.5 25C2.5 12.297 12.797 2 25.5 2ZM33.434 34.375C33.857 33.077 35.839 20.141 36.084 17.592C36.158 16.82 35.914 16.307 35.436 16.078C34.858 15.8 34.002 15.939 33.009 16.297C31.647 16.788 14.235 24.181 13.229 24.609C12.275 25.014 11.373 25.456 11.373 26.096C11.373 26.546 11.64 26.799 12.376 27.062C13.142 27.335 15.071 27.92 16.21 28.234C17.307 28.537 18.556 28.274 19.256 27.839C19.998 27.378 28.561 21.648 29.176 21.146C29.79 20.644 30.28 21.287 29.778 21.79C29.276 22.292 23.398 27.997 22.623 28.787C21.682 29.746 22.35 30.74 22.981 31.138C23.702 31.592 28.887 35.07 29.668 35.628C30.449 36.186 31.241 36.439 31.966 36.439C32.691 36.439 33.073 35.484 33.434 34.375Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.c881ca27c3c7afbf42fdbef3ab082d01.svg";
export { ForwardRef as ReactComponent };